// Locale copy-bundle registry.
//
// Bundles are GENERATED from global.json by `npm run gen:locales`
// (scripts/gen-locale-bundles.mjs), which rewrites this file. English is
// intentionally absent (inline source) — see docs/PLAN.md decision #2.
//
// --- GENERATED IMPORTS BELOW (do not edit by hand) ---
import ja from './ja.js';

export const LOCALE_BUNDLES = {
  'ja': ja,
};
